"use client";

import Script from "next/script";

interface HubspotEmbedFormProps {
  portalId: string;
  formId: string;
  region?: string;
  className?: string;
}

/**
 * HubSpot "raw HTML" form embed (portal-scoped developer script). Renders
 * the form's own markup directly into the target div — no iframe — so it
 * can be restyled to match the page via the `.wf-hubspot-form` overrides in
 * globals.css.
 */
export function HubspotEmbedForm({
  portalId,
  formId,
  region = "na1",
  className,
}: HubspotEmbedFormProps) {
  return (
    <div className={className}>
      <Script
        src={`https://js.hsforms.net/forms/embed/developer/${portalId}.js`}
        strategy="lazyOnload"
      />
      <div
        className="hs-form-html wf-hubspot-form"
        data-region={region}
        data-form-id={formId}
        data-portal-id={portalId}
      />
    </div>
  );
}
